import {
  aMatchList,
  anUpdateMatchList,
  mockUpdateMatchListOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateMatchListHandler = ({
  id,
  name,
  description,
  timeToLiveInSeconds,
}) => ({
  __typename: 'Mutation',
  updateMatchList: {
    ...anUpdateMatchList(),
    data: aMatchList({
      defaultTtl: timeToLiveInSeconds,
      description,
      id,
      name,
      targetColumn: '1',
    }),
  },
});

export const handlers = [
  mockUpdateMatchListOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateMatchList: anUpdateMatchList(),
        },
      });
    }
  ),
];
